import { useSdfToast } from '@pequity/shared/composables';
import { useIdle } from '@vueuse/core';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { isDev, isOidcSession } from '@/utils/helpers';

const IDLE_TIMEOUT_MS = 60 * 60 * 1000;

export const useIdleSessionTimeout = () => {
  if (isDev) return;

  const authStore = useAuthStore();
  const router = useRouter();
  const toast = useSdfToast();
  const { t } = useI18n();
  const { idle } = useIdle(IDLE_TIMEOUT_MS);
  const isLoggingOut = ref(false);

  watch(idle, async (isIdle) => {
    if (isIdle && authStore.loggedIn && !isLoggingOut.value && !isOidcSession()) {
      isLoggingOut.value = true;
      const currentPath = router.currentRoute.value.fullPath;

      await authStore.logout();

      await router.push({ name: 'welcome-back', query: { redirect: currentPath } });

      toast.error(t('app.session_expired_due_to_inactivity'));
    }
  });
};
